module.exports = __webpack_public_path__ + "static/media/pickup-map-phoenix.7b33e2e0.png";